import { P } from '@ahmdigital/ui';

import { StyledSmall } from './shared';

const limitsRollover = {
  disclaimer: {
    choosable: (
      <P>
        <StyledSmall>=</StyledSmall>Restrictions on how many services you can use each year (e.g. 2 dental check-ups per
        financial year) and waiting periods may apply. Where routine dental is part of a shared limit, all services on
        that limit will rollover.
      </P>
    ),
    default: (
      <P>
        <StyledSmall>=</StyledSmall>Restrictions on how many services you can use each year (e.g. 2 dental check-ups per
        financial year) and waiting periods may apply. Where routine dental is part of a shared limit, all services on
        that limit will rollover.
      </P>
    ),
    flexiLimits: (
      <P>
        <StyledSmall>=</StyledSmall>Rollover excludes optical where it has a separate limit. Restrictions on how many
        services you can use each year will continue to apply. Waiting periods may apply.
      </P>
    ),
    superExtras: (
      <P>
        <StyledSmall>=</StyledSmall>Rollover excludes: optical and orthodontics where they have a separate annual limit;
        pre and post-natal services and joint fluid replacement injection rolling year limits; laser eye surgery and
        orthodontics lifetime limits; hearing aid limits which reset every 3 financial years. Restrictions on how many
        services you can use each year will continue to apply. Waiting periods may apply.
      </P>
    ),
  },
  rollingOverLimitsText: {
    choosable: 'unused teeth annual limits',
    default: 'unused routine dental annual limits',
    flexiLimits: 'most unused extras annual limits ',
    superExtras: 'most unused extras annual limits',
  },
};

export default limitsRollover;
